import { useMemo, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { DOOR_FETCH_ERROR, DOOR_FETCH_SUCCESS } from "../../Reducer/DoorSlice";
import API from "../../Network/API";
import { useEffect } from "react";
import Paginate from "../../CustomHook/Paginate";
import { Link, useParams } from "react-router-dom";

import OfflineNav from "./OfflineNav";
import { OFFLINE_ID_FETCH_SUCCESS } from "../../Reducer/offlineIDSlice";
import { useSortableTable } from "../../Component/Table/useSortableTable";
import TableHead from "../../Component/Table/TableHead";
import TableBody from "../../Component/Table/TableBody";
import Agent from "../../Network/Agent";

export default function OfflineDoor() {

    const dispatch = useDispatch();
    const selector = useSelector((state) => state.doorOfflineReducer)
    const selector_status = useSelector((state) => state.doorStatusReducer)
    const sites = selector?.data?.sites || [];
    const [sortField, setSortField] = useState("");
    const [sortOrder, setSortOrder] = useState("asc");
    const [page, setPage] = useState(1);
    const [site_id, setSiteId] = useState("");
    const ddd = useParams();


    useEffect(() => {

        const array_data={
            hours_type: ddd.id,
            page: page,
            site_id:site_id
        };
        if(page!=1){
            Agent.All_SITE.offline_sites(dispatch,array_data,true);
        }
        Agent.All_SITE.offline_sites(dispatch,array_data);
        dispatch(OFFLINE_ID_FETCH_SUCCESS(ddd.id))

    }, [ddd.id,page,site_id]);


      useEffect(() => {

        setPage(0);

    }, []);


    const searchSite = (site_code) => {
        setSiteId(site_code);
    }


    const syncData = () => {
    
    }

    const columns = [
        { label: "Last Updated", accessor: "update_time",className:"text-start" },
        { label: "Cluster", accessor: "cluster.name",className:"text-start" },
        { label: "Zone", accessor: "zone.name" ,className:"text-start"},
        { label: "Site ID", accessor: "site_id" ,className:"text-start"},
        { label: "Tenant Site ID", accessor: "customer_site_id",className:"text-start" },
        { label: "Site Name", accessor: "site_name",className:"text-start" },
        { label: "Network", accessor: "network_val",className:"text-start" },
        { label: "Elapsed Time", accessor: "last_active_time",className:"text-center fw-bold" },
    ];

    const [tableData, handleSorting] = useSortableTable(sites);
    // Refresh tableData when Redux `sites` updates
    useEffect(() => {
        handleSorting(sortField, sortOrder);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [sites]);

    const handleSortingChange = (accessor) => {
        const order = accessor === sortField && sortOrder === "asc" ? "desc" : "asc";
        setSortField(accessor);
        setSortOrder(order);
        handleSorting(accessor, order);
    };

    return (
        <>
            <div className="row">
                <div className="row text-center  mb-2 mt-2">


                    <div className="d-flex justify-content-end">
                        <div class="input-group input-group-sm max-with-searbar">
                            <input type="text" onChange={(e) => searchSite(e.target.value)} class="form-control" placeholder="search by site id...." />
                            <button class="btn btn-success" type="button"><i class="fa-light fa-search" /></button>
                        </div>
                        <button class="btn btn-warning  ms-2 me-2" type="button" onClick={() => syncData()}><i class="fa-light fa-refresh me-1" />Sync</button>




                        <OfflineNav data={selector?.data} active={ddd.id} />

                    </div>

                </div>
            </div>

            <div className="table-responsive">
 {selector?.loading && <div className="text-center">Loading......</div>}
                <table className="table table-bordered table-striped m-0 table-sm bg-white text-center">
                    <TableHead
                        columns={columns}
                        sortField={sortField}
                        sortOrder={sortOrder}
                        handleSorting={handleSortingChange}
                    />
                    <TableBody columns={columns} tableData={tableData} />
                </table>



            </div>

        </>
    );

}